import { observer } from 'mobx-react';
import * as React from 'react';
import { useStores } from '../stores/RootStore';

interface IsHardAuthProps {
  children: React.ReactNode;
}

export const IsHardAuthOrDealer = observer((props: IsHardAuthProps) => {
  const { ssoStore } = useStores();
  if (ssoStore.isLoggedInWithHardAuth) {
    return <>{props.children}</>;
  }
  return <></>;
});
